import { useContext, useEffect, useState } from "react";
import styles from "../styles/ChatbotSettings.module.css";
import { ChatbotPreview } from "./ChatbotPreview";
import { HexColorPicker } from "react-colorful";
import { IoChevronDown, IoRemove } from "react-icons/io5";
import { LanguageContext } from "./App";
import React from "react";
import { updateAppearence } from "./UploadChatBot";
import ReactLoading from "react-loading";
import { TfiSave } from "react-icons/tfi";

export default function Appearence({ chatbot }) {
  const [firstMessage, setfirstMessage] = useState(chatbot.firstMessage);
  const [companyName, setCompanyName] = useState(chatbot.companyName);
  const [header, setheader] = useState(chatbot.header);
  const [subHeader, setsubHeader] = useState(chatbot.subHeader);
  const [whatsapplink, setwhatsapplink] = useState(chatbot.whatsapplink);
  const [telegramlink, settelegramlink] = useState(chatbot.telegramlink);
  const [mainColor, setmainColor] = useState(chatbot.mainColor);
  const [humanSpeech, sethumanSpeech] = useState(chatbot.humanSpeech);
  const [aiSpeech, setaiSpeech] = useState(chatbot.aiSpeech);
  const [supportSpeech, setSupportSpeech] = useState(chatbot.supportSpeech);
  const [backgroundColor, setbackgroundColor] = useState(
    chatbot.backgroundColor
  );
  const [userInputColor, setuserInputColor] = useState(chatbot.userInputColor);
  const [messageText, setmessageText] = useState(chatbot.messageText);
  const [closeButton, setcloseButton] = useState(chatbot.closeButton);
  const [advanced, setAdvanced] = useState(false);
  const [theme, setTheme] = useState("l");

  const [enterEmailText, setenterEmailText] = useState(chatbot.enterEmailText);

  const [loading, setLoading] = useState(false);

  const [language, setLanguage] = useContext(LanguageContext);

  // Integration and Emebding tabs

  async function save() {
    const hexColorRegex = /^#([0-9a-fA-F]{6})$/;

    if (
      hexColorRegex.test(mainColor) &&
      hexColorRegex.test(humanSpeech) &&
      hexColorRegex.test(aiSpeech) &&
      hexColorRegex.test(backgroundColor) &&
      hexColorRegex.test(userInputColor) &&
      hexColorRegex.test(messageText) &&
      hexColorRegex.test(closeButton)
    ) {
      setLoading(true);
      await updateAppearence(
        chatbot.name,
        companyName,

        firstMessage,
        header,
        subHeader,
        whatsapplink,
        telegramlink,
        mainColor,
        humanSpeech,
        aiSpeech,
        supportSpeech,
        backgroundColor,
        userInputColor,
        messageText,
        closeButton
      );
      setLoading(false);
    } else {
      if (language === "en") {
        alert("Please, enter ");
      } else {
        alert("Пожалуйста, введите a valid 6-digit HEX color code!");
      }

      return;
    }
  }

  return (
    <div className={styles.main}>
      <div
        style={{
          borderRadius: 12,
          width: "50vw",
          right: 0,
          margin: 20,
          padding: 20,
          height: "100vh",
          fontFamily: "Jost",
          fontWeight: 600,
          scrollbarWidth: "none",
          overflow: "scroll",
        }}
      >
        {loading ? (
          <div
            style={{
              display: "flex",
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "transparent",
            }}
          >
            <ReactLoading type="spin" color="#000" height={75} width={75} />
          </div>
        ) : null}
        <Param
          name={language === "en" ? "Name of the chatbot: " : "Имя чат-бота: "}
          defaultValue={header}
          setValue={setheader}
          setValue2={undefined}
          setValue3={undefined}
          color={false}
        ></Param>
        <Param
          name={
            language === "en"
              ? "Your company name: "
              : "Название вашей компании:"
          }
          defaultValue={companyName}
          setValue={setCompanyName}
          setValue2={undefined}
          setValue3={undefined}
          color={false}
        ></Param>
        <Param
          name={language === "en" ? "Subheader: " : "Подзаголовок: "}
          defaultValue={subHeader}
          setValue={setsubHeader}
          setValue2={undefined}
          setValue3={undefined}
          color={false}
        ></Param>
        <Param
          name={language === "en" ? "First message: " : "Первое сообщение: "}
          defaultValue={firstMessage}
          setValue={setfirstMessage}
          setValue2={undefined}
          setValue3={undefined}
          color={false}
        ></Param>
        <Param
          name={
            language === "en"
              ? "WhatsApp link (you can leave it blank): "
              : "Ссылка на WhatsApp (можно оставить пустым): "
          }
          defaultValue={whatsapplink}
          setValue={setwhatsapplink}
          setValue2={undefined}
          setValue3={undefined}
          color={false}
        ></Param>
        <Param
          name={
            language === "en"
              ? "Telegram link (you can leave it blank): "
              : "Ссылка на Telegram (можно оставить пустым): "
          }
          defaultValue={telegramlink}
          setValue={settelegramlink}
          setValue2={undefined}
          setValue3={undefined}
          color={false}
        ></Param>

        <div style={{ marginTop: 40 }}></div>

        <label style={{ color: "#000" }}>
          {language === "en" ? "Theme: " : `Тема: `}
        </label>
        <div className="radio">
          <label style={{ color: "#000" }}>
            <input
              type="checkbox"
              checked={theme === "l"}
              onChange={() => {
                setTheme("l");
                setbackgroundColor("#ffffff");
                setuserInputColor("#000000");
              }}
            />
            {language === "en" ? " Light" : ` Светлая`}
          </label>
        </div>
        <div className="radio">
          <label style={{ color: "#000" }}>
            <input
              type="checkbox"
              checked={theme === "d"}
              onChange={() => {
                setTheme("d");
                setbackgroundColor("#111111");
                setuserInputColor("#ffffff");
              }}
            />
            {language === "en" ? " Dark" : ` Темная`}
          </label>
        </div>

        <Param
          name={language === "en" ? "Main: " : "Главный: "}
          defaultValue={mainColor}
          setValue={setmainColor}
          setValue2={setaiSpeech}
          setValue3={setSupportSpeech}
          color={true}
        ></Param>

        <div className="radio" style={{ color: "#000" }}>
          <label>
            <input
              type="checkbox"
              checked={advanced}
              onChange={() => {
                setAdvanced(!advanced);
              }}
            />

            {language === "en"
              ? " Advanced settings"
              : ` Расширенные настройки`}
          </label>
        </div>

        {advanced ? (
          <div>
            <Param
              name={
                language === "en" ? "Human's message" : "Сообщение человека: "
              }
              defaultValue={humanSpeech}
              setValue={sethumanSpeech}
              setValue2={undefined}
              setValue3={undefined}
              color={true}
            ></Param>
            <Param
              name={language === "en" ? "AI message: " : "Сообщение бота: "}
              defaultValue={aiSpeech}
              setValue={setaiSpeech}
              setValue2={undefined}
              setValue3={undefined}
              color={true}
            ></Param>
            <Param
              name={
                language === "en"
                  ? "Support (human) message: "
                  : "Сообщение оператора: "
              }
              defaultValue={supportSpeech}
              setValue={setSupportSpeech}
              setValue2={undefined}
              setValue3={undefined}
              color={true}
            ></Param>
            <Param
              name={language === "en" ? "Background: " : "Задний фон: "}
              defaultValue={backgroundColor}
              setValue={setbackgroundColor}
              setValue2={undefined}
              setValue3={undefined}
              color={true}
            ></Param>
            <Param
              name={
                language === "en"
                  ? "Text of messages"
                  : "Цвет текста сообщений: "
              }
              defaultValue={messageText}
              setValue={setmessageText}
              setValue2={undefined}
              setValue3={undefined}
              color={true}
            ></Param>
            <Param
              name={
                language === "en"
                  ? "Input field text: "
                  : "Цвет текста в поле ввода: "
              }
              defaultValue={userInputColor}
              setValue={setuserInputColor}
              setValue2={undefined}
              setValue3={undefined}
              color={true}
            ></Param>
            <Param
              name={language === "en" ? "Close button" : "Кнопка закрытия: "}
              defaultValue={closeButton}
              setValue={setcloseButton}
              setValue2={undefined}
              setValue3={undefined}
              color={true}
            ></Param>
          </div>
        ) : null}

        <button
          className={styles.submitBtn}
          style={{
            marginBottom: 50,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
          onClick={() => {
            save();
          }}
        >
          <TfiSave style={{ marginRight: 5 }} size={18} />
          {language === "en" ? "Save" : "Сохранить"}
        </button>
      </div>
      <div className={styles.showcaseContainer}>
        <ChatbotPreview
          firstMessage={firstMessage}
          header={header}
          subHeader={subHeader}
          whatsapplink={whatsapplink}
          telegramlink={telegramlink}
          mainColor={mainColor}
          humanSpeech={humanSpeech}
          aiSpeech={aiSpeech}
          supportSpeech={supportSpeech}
          backgroundColor={backgroundColor}
          userInputColor={userInputColor}
          messageText={messageText}
          closeButton={closeButton}
          enterEmailText={enterEmailText}
        ></ChatbotPreview>
      </div>
    </div>
  );
}

function Param({
  name,
  defaultValue,
  setValue,
  color,

  setValue2,
  setValue3,
}) {
  const [colorPicker, setColorPicker] = useState(false);
  const [colorChosen, setColorChosen] = useState(defaultValue);
  const [language, setLanguage] = useContext(LanguageContext);

  useEffect(() => {
    setValue(colorChosen);

    if (setValue2 !== undefined) {
      setValue2(colorChosen);
      setValue3(colorChosen);
    }
  }, [colorChosen]);

  if (color) {
    return (
      <div>
        <div
          className={styles.paramDivColor}
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <button
            style={{
              padding: "5px",
              backgroundColor: "transparent",
              border: "none",
            }}
            onClick={() => {
              setColorPicker(!colorPicker);
            }}
          >
            {colorPicker ? (
              <IoRemove size={20} color="#000" height={5} width={5} />
            ) : (
              <IoChevronDown size={20} color="#000" height={5} width={5} />
            )}
          </button>
          <h4
            className={styles.paramName}
            style={{ marginRight: 10, color: "#000" }}
          >
            {name}
          </h4>

          <input
            className={styles.paramInputColor}
            value={defaultValue}
            placeholder={
              language === "en"
                ? "Enter HEX color code..."
                : "Введите HEX код цвета..."
            }
            onChange={(event) => {
              setColorChosen(event.target.value);
            }}
          ></input>
        </div>
        {colorPicker ? (
          <HexColorPicker color={defaultValue} onChange={setColorChosen} />
        ) : null}
      </div>
    );
  } else {
    return (
      <div style={{}}>
        <h4 className={styles.paramName} style={{ color: "#000" }}>
          {name}{" "}
        </h4>
        <input
          className={styles.paramInput}
          defaultValue={defaultValue}
          placeholder={
            language === "en" ? "Enter a value..." : "Введите значение..."
          }
          onChange={(event) => {
            setValue(event.target.value);
          }}
        ></input>
      </div>
    );
  }
}
